<template>
  <v-sheet width="300px" height="100px">
    <canvas :id="guid" width="300" height="100" />
    <v-dialog activator="parent" width="600">
      <v-card subtitle="ИНФОРМАЦИЯ">
        <template v-slot:text>
          <p v-for="el in report_data" :key="el">
            <span class="font-weight-bold">Неделя {{ el.week }}: </span>
            <span>{{ el.indicator.toFixed(2) }}</span>
          </p>
        </template>
      </v-card>
    </v-dialog>
  </v-sheet>
</template>

<script>
import { Chart } from "chart.js"

export default {
  name: 'ReportByWeek',
  props: ['report_data', 'guid', 'name'],
  mounted() {
    this.canvas = document.getElementById(this.guid).getContext('2d')
    this.make_chart()
  },
  data() {
    return {
      graph: null,
      canvas: null,
      weeks: null,
      indicators: null
    }
  },
  methods: {
    make_chart: function() {
      this.update_data()
      if (this.canvas) {
        this.graph = new Chart(this.canvas, {
          type: 'line',
          data: {
            labels: this.weeks,
            datasets: [{
              label: this.name,
              data: this.indicators,
              borderColor: '#505050',
              backgroundColor: '#505050',
              pointStyle: 'circle',
              pointRadius: 2,
              pointHoverRadius: 7
            }]
          },
          options: {
            plugins: {
              legend: {
                display: false
              }
            }
          }
        })
      }
    },
    update_data: function () {
      this.weeks =      this.report_data.map(el => el.week)
      this.indicators = this.report_data.map(el => el.indicator)
    },
    update_chart: function () {
      this.update_data()
      this.graph.destroy()
      this.canvas = document.getElementById(this.uuid).getContext('2d')
      this.make_chart()
    }
  }
}
</script>

<style scoped>

</style>